import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getStatementList,
	addNewStatement,
	updateStatement,
	deleteStatement,
	getStatement
} from '../statement/thunk';

export const initialState = {
	itemStatementList: [],
	itemStatement: null,
	isStatementLoading: false,
	isStatementSuccess: false,

	dataStatement: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false
};

const StatementSlice = createSlice({
	name: 'Statements',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getStatement.fulfilled, (state, action) => {
			state.isStatementLoading = false;
			state.isStatementSuccess = true;
			state.itemStatement = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getStatement.pending, state => {
			state.isStatementLoading = true;
			state.isStatementSuccess = null;
			state.itemStatement = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getStatement.rejected, (state, action) => {
			state.isStatementLoading = false;
			state.isStatementSuccess = false;
			state.itemStatement = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getStatementList.pending, state => {
			state.isStatementSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getStatementList.fulfilled, (state, action) => {
			state.itemStatementList = action.payload;
			state.statementList = action.payload;
			state.isLoadingList = false;
			state.isStatementSuccess = true;

			let statementListSelect = [];
			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.statementListSelect = statementListSelect;
		});
		builder.addCase(getStatementList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isStatementSuccess = true;
		});
		builder.addCase(addNewStatement.fulfilled, (state, action) => {
			state.itemStatementList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewStatement.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewStatement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateStatement.fulfilled, (state, action) => {
			state.itemStatementList = state.itemStatementList.map(statement =>
				statement.statementname === action.payload.old_statement
					? { ...statement, ...action.payload.updated_statement }
					: statement
			);
			state.statementList = state.statementList.map(statement =>
				statement._id.toString() === action.payload._id.toString()
					? { ...statement, ...action.payload }
					: statement
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateStatement.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateStatement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteStatement.fulfilled, (state, action) => {
			state.itemStatementList = current(state.itemStatementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementList = current(state.statementList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteStatement.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteStatement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const {
	setRequireCloseModal
} = StatementSlice.actions;

export default StatementSlice.reducer;